/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_Faq_Q7Inputs */

const en_viewer_faq_q7 = /** @type {(inputs: Viewer_Faq_Q7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I copy the path to a value?`)
};

const ko_viewer_faq_q7 = /** @type {(inputs: Viewer_Faq_Q7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`값의 경로를 복사할 수 있나요?`)
};

const ja_viewer_faq_q7 = /** @type {(inputs: Viewer_Faq_Q7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`値のパスをコピーできますか`)
};

/**
* | output |
* | --- |
* | "Can I copy the path to a value?" |
*
* @param {Viewer_Faq_Q7Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_faq_q7 = /** @type {((inputs?: Viewer_Faq_Q7Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_Faq_Q7Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_faq_q7(inputs)
	if (locale === "ko") return ko_viewer_faq_q7(inputs)
	return ja_viewer_faq_q7(inputs)
});